import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm} from '@angular/forms';
import { DateFilterFn } from '@angular/material/datepicker';
import { getTimeRemoveTimezoneOffset } from 'src/app/shared/utils/helper';
@Component({
  selector: 'fx-time-condition',
  templateUrl: './time-condition.component.html',
  styleUrls: ['./time-condition.component.sass']
})
export class TimeConditionComponent implements OnInit {

  @Input() datepickerFilter: DateFilterFn<Date>;
  @Output() emitTime = new EventEmitter();
  @Output() emitEvent = new EventEmitter();
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  timeInfo: any = {
    tf: 'day',
  };
  isEnableChangeRangeTime = false;
  constructor() {
    const d = new Date();
    const start = new Date(d.setMonth(d.getMonth() - 1));
    const end = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    end.setHours(0);
    end.setMinutes(0);
    end.setSeconds(0);
    this.range.patchValue({
      start: start,
      end: end
    })
  }

  ngOnInit(): void {
  }

  onApplyTime(): void {
    if (this.range.valid) {
      const option = {
        timeframe: this.timeInfo.tf,
        from: getTimeRemoveTimezoneOffset(this.range.get('start').value),
        to: getTimeRemoveTimezoneOffset(this.range.get('end').value)
      }
      this.emitTime.emit(option);
    }
    else {
      this.range.markAllAsTouched();
    }
  }

  onTimeFrameChanged(tf: string): void {
    this.timeInfo.tf = tf;
    this.isEnableChangeRangeTime = (this.timeInfo.tf === 'customize');
    if (this.timeInfo.tf !== 'customize') {
      this.onApplyTime();
    }
  }
}
